export default "__VITE_ASSET__C94KYnlY__"